import { useMemo } from "react";
import { getSessionStorageUser } from "../../../../services/session/auth.service";
import { useTodaysAppointments } from "../../../../hooks/useTodaysAppointments";
import { useMinuteTick } from "../../../../hooks/useMinuteTick";
import { selectTodaysAppointments } from "./appointments-rail.service";

/**
 * Loads today's appointments once and caches the result for both the expanded
 * list and the collapsed count, so the count can never disagree with the list
 * and no extra request is made.
 *
 * Returns the cards, loading state, and error state (the count is hidden while
 * loading or on error so a failed load never reads as "0 appointments").
 */
export const useTodaysAppointmentCards = () => {
	const sessionUser = getSessionStorageUser();
	const { appointments, types, isLoading, isError } = useTodaysAppointments(sessionUser?.id);
	const now = useMinuteTick();
	const cards = useMemo(
		() => selectTodaysAppointments(appointments, types, now),
		[appointments, types, now]
	);

	return { cards, isLoading, isError };
};
